// * Create by jiangjijing on 2020/3/2
import api from '../config/apiConfig'
export default {
  checkNumberInt (val) {
    if (val.length == 1) {
      val = val.toString().replace(/[^1-9]/g, '')
      val = val ? parseInt(val) : ''
      return val
    } else {
      val = val.toString().replace(/\D/g, '')
      val = val ? parseInt(val) : ''
      return val
    }
  },
  checkNumberIntZ (val) {
    if (val.length == 1) {
      val = val.toString().replace(/[^0-9]/g, '')
      val = val ? parseInt(val) : ''
      return val
    } else {
      val = val.toString().replace(/\D/g, '')
      val = val ? parseInt(val) : ''
      return val
    }
  },
  checkNumberFloat (val) {
    val = val.toString().replace(/[^\d.]/g, '')
    val = val.toString().replace(/^\./g, '')
    val = val.toString().replace(/\.{2,}/g, '.')
    val = val.toString().replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
    // 两位小数
    // val = val.toString().replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
    val = val ? parseFloat(val).toFixed(2) : ''
    return val
  },
  checkNumberFloatF (val) {
    val = val.toString().replace(/[^\d.-]/g, '')
    val = val.toString().replace(/^\./g, '')
    val = val.toString().replace(/\.{2,}/g, '.')
    val = val.toString().replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
    val = val ? parseFloat(val).toFixed(2) : ''
    return val
  },
  checkNumberFloat1 (val) {
    val = val.toString().replace(/[^\d.]/g, '')
    val = val.toString().replace(/^\./g, '')
    val = val.toString().replace(/\.{2,}/g, '.')
    val = val.toString().replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
    // 一位小数
    val = val ? parseFloat(val).toFixed(1) : ''
    return val
  },
  checkNumberFloat2 (val) {
    val = val.toString().replace(/[^\d.]/g, '')
    val = val.toString().replace(/^\./g, '')
    val = val.toString().replace(/\.{2,}/g, '.')
    val = val.toString().replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
    // 两位小数
    val = val.toString().replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    return val
  },
  checkNumberFloatOne (val) {
    val = val.toString().replace(/[^\d.]/g, '')
    val = val.toString().replace(/^\./g, '')
    val = val.toString().replace(/\.{2,}/g, '.')
    val = val.toString().replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
    // 一位小数
    val = val.toString().replace(/^(-)*(\d+)\.(\d).*$/, '$1$2.$3')
    val = val ? parseFloat(val) : ''
    return val
  },
  getButtons: function (buttonCode, buttonList) {
    let pro = {}
    pro = buttonList.find(item => {
      return item === buttonCode
    })
    if (pro) {
      return true
    } else {
      return false
    }
  },
  checkRouter: function (path) {
    let indexCode = ''
    let menuList = api.sGetObject('menuList')
    if (path == '/partsConsume') {
      indexCode = '10026'
    } else if (path == '/vehicleConfig') {
      indexCode = '10024'
    } else if (path == '/vehicleTypeConfig') {
      indexCode = '10025'
    } else if (path == '/performanceConfig') {
      indexCode = '10005'
    } else if (path === '/driverInlist') {
      indexCode = '10002'
    } else if (path === '/driverInfo') {
      indexCode = '10027'
    } else if (path === '/contractConfig') {
      indexCode = '10028'
    } else if (path === '/histroyPerformance') {
      indexCode = '10029'
    } else if (path == '/userConfig') {
      indexCode = '10001'
    } else if (path == '/account') {
      indexCode = '10030'
    } else if (path == '/employeesConfig') {
      indexCode = '10006'
    } else if (path == '/role') {
      indexCode = '10031'
    } else if (path == '/fileConfig') {
      indexCode = '10007'
    } else if (path == '/trainSignIn') {
      indexCode = '10004'
    } else if (path == '/businessSignUp') {
      indexCode = '10003'
    }
    else if (path == '/quotaConfig') {
      indexCode = '10072'
    }
    else if (path == '/marketingConfig') {
      indexCode = '10071'
    }
    else if (path == '/marketingClewConfig') {
      indexCode = '10070'
    }
    else if (path == '/dataView') {
      indexCode = '10085'
    }
    else if (path == '/weChatConfig') {
      indexCode = '10086'
    }
    else if (path == '/mairuiCoin') {
      indexCode = '10088'
    }
    else if (path == '/recruit') {
      indexCode = '10089'
    }
    else if (path == '/applicantInfo') {
      indexCode = '10090'
    }
    else if (path == '/usedCar') {
      indexCode = '10091'
    }
    else if (path == '/repairParts') {
      indexCode = '10111'
    }
    else if (path == '/stockConfig') {
      indexCode = '10112'
    }
    let pro = {}
    pro = this.getCurrentPart(indexCode, menuList)
    if (pro) {
      return true
    } else {
      return false
    }
  },
  getCurrentPart (code, items) {
    var stark = []
    stark = stark.concat(items)
    while (stark.length) {
      var temp = stark.shift()
      if (temp.children) {
        stark = temp.children.concat(stark)
      }
      if (code === temp.code) {
        return temp
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/commonFunctions/commonFunctions.js